import Black from './land-icons/Black';
import Blue from './land-icons/Blue';
import Green from './land-icons/Green';
import Red from './land-icons/Red';
import White from './land-icons/White';

const ManaCost = ({ manaCost }) => {
  if (!manaCost) return null;

  // Parse the mana cost string to extract symbols
  // Mana costs are typically in the format {W}{U}{B}{R}{G} or similar
  const regex = /\{([^}]+)\}/g;
  const matches = [...manaCost.matchAll(regex)];
  const symbols = matches.map((match) => match[1]);

  const renderManaSymbol = (symbol) => {
    switch (symbol) {
      case 'W':
        return (
          <span className='inline-block w-4 h-4 mx-0.5'>
            <White />
          </span>
        );
      case 'U':
        return (
          <span className='inline-block w-4 h-4 mx-0.5'>
            <Blue />
          </span>
        );
      case 'B':
        return (
          <span className='inline-block w-4 h-4 mx-0.5'>
            <Black />
          </span>
        );
      case 'R':
        return (
          <span className='inline-block w-4 h-4 mx-0.5'>
            <Red />
          </span>
        );
      case 'G':
        return (
          <span className='inline-block w-4 h-4 mx-0.5'>
            <Green />
          </span>
        );
      default:
        // For colorless or other special mana symbols
        return <span className='inline-flex items-center justify-center w-4 h-4 mx-0.5 bg-gray-300 dark:bg-gray-600 rounded-full text-xs'>{symbol}</span>;
    }
  };

  return (
    <div className='flex items-center gap-0.5'>
      {symbols
        .filter((symbol) => symbol !== '')
        .map((symbol, index) => (
          <span className='flex items-center' key={index}>
            {renderManaSymbol(symbol)}
          </span>
        ))}
    </div>
  );
};

export default ManaCost;
